import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Flex,
  Heading,
  HStack,
  IconButton,
  Image,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { RefObject, useRef, useState } from "react";

const calc = (input: string, level: number = 0): number => {
  let res = null;
  if (input.indexOf("+") !== -1) {
    let [a, b] = input.split("+");
    if (b.indexOf("%") !== -1) {
      b = b.substr(0, b.indexOf("%"));
      let c = (parseFloat(a) / 100) * parseFloat(b);
      res = calc(a, level + 1) + calc(c.toString(), level + 1);
    } else {
      res = calc(a, level + 1) + calc(b, level + 1);
    }
  } else if (input.indexOf("-") !== -1) {
    let [a, b] = input.split("-");
    if (b.indexOf("%") !== -1) {
      b = b.substr(0, b.indexOf("%"));
      let c = (parseFloat(a) / 100) * parseFloat(b);
      res = calc(a, level + 1) - calc(c.toString(), level + 1);
    } else {
      res = calc(a, level + 1) - calc(b, level + 1);
    }
  } else if (input.indexOf("*") !== -1) {
    let [a, b] = input.split("*");
    if (b.indexOf("%") !== -1) {
      b = b.substr(0, b.indexOf("%"));
      let c = (parseFloat(a) / 100) * parseFloat(b);
      res = calc(a, level + 1) * calc(c.toString(), level + 1);
    } else {
      res = calc(a, level + 1) * calc(b, level + 1);
    }
  } else if (input.indexOf("/") !== -1) {
    let [a, b] = input.split("/");
    if (b.indexOf("%") !== -1) {
      b = b.substr(0, b.indexOf("%"));
      let c = (parseFloat(a) / 100) * parseFloat(b);
      res = calc(a, level + 1) / calc(c.toString(), level + 1);
    } else {
      res = calc(a, level + 1) / calc(b, level + 1);
    }
  } else {
    res = parseFloat(input);
  }
  if (res === null || isNaN(res)) return 0;
  return res;
};

const Calculator = (props: {}) => {
  const bgRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const caseRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const [expression, setExpression] = useState("");

  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: false });

  const submitExpression = () => {
    setExpression(calc(expression).toString());
  };

  return (
    <Box pos="relative" w="100%">
      <Heading
        cursor="pointer"
        size="md"
        variant="editor"
        textAlign="center"
        onClick={onToggle}
      >
        Калькулятор
      </Heading>
      <IconButton
        pos="absolute"
        top={".5rem"}
        right={".5rem"}
        icon={
          isOpen ? (
            <ChevronUpIcon boxSize={"3rem"} />
          ) : (
            <ChevronDownIcon boxSize={"3rem"} />
          )
        }
        aria-label={isOpen ? "Свернуть" : "Раскрыть"}
        onClick={onToggle}
      />
      <Collapse
        unmountOnExit={false}
        in={isOpen}
        animateOpacity
        startingHeight={0}
      >
        <Flex
          pos="relative"
          align="center"
          justify="center"
          ref={bgRef}
          w="100%"
          h="50%"
        >
          <Box
            pos="absolute"
            ref={caseRef}
            top="8%"
            left="23%"
            width="55%"
            marginTop="8%"
          >
            <Image
              src={process.env.PUBLIC_URL + "/images/calculator/Case.png"}
            />
            <Box pos="absolute" top="5%" left="5%" width="90%">
              <Image
                src={process.env.PUBLIC_URL + "/images/calculator/screen.png"}
              />
              <Box
                fontFamily="'Coda', cursive;"
                pos="absolute"
                bottom="2%"
                right="7%"
                lineHeight="3rem"
                fontSize="2rem"
                overflow="hidden"
                w="90%"
                h="3rem"
                textAlign="right"
              >
                {expression}
              </Box>
            </Box>
            <VStack w="90%" position="absolute" left="5%" bottom="5%">
              <HStack
                w="90%"
                justify="space-between"
                marginTop={[null, null, "1rem!important"]}
              >
                <Image
                  cursor="pointer"
                  src={process.env.PUBLIC_URL + "/images/calculator/7.png"}
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "7")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/8.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "8")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/9.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "9")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/div.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "/")}
                />
              </HStack>
              <HStack
                w="90%"
                justify="space-between"
                marginTop={[null, null, "1rem!important"]}
              >
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/4.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "4")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/5.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "5")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/6.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "6")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/mult.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "*")}
                />
              </HStack>
              <HStack
                w="90%"
                justify="space-between"
                pos="relative"
                marginTop={[null, null, "1rem!important"]}
              >
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/1.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "1")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/2.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "2")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/3.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "3")}
                />
                <Box
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  height="1px"
                >
                  &nbsp;
                </Box>
                <Image
                  cursor="pointer"
                  pos="absolute"
                  top="0"
                  right="0"
                  height="auto"
                  src={process.env.PUBLIC_URL + "/images/calculator/plus.png"}
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "+")}
                />
              </HStack>
              <HStack
                w="90%"
                justify="space-between"
                marginTop={[null, null, "1rem!important"]}
              >
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/0.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "0")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/point.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + ".")}
                />
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/minus.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "-")}
                />
                <Box
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  height="1px"
                >
                  &nbsp;
                </Box>
              </HStack>
              <HStack
                w="90%"
                justify="space-between"
                marginTop={[null, null, "1rem!important"]}
              >
                <Image
                  src={process.env.PUBLIC_URL + "/images/calculator/clear.png"}
                  cursor="pointer"
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression("")}
                />
                <Image
                  cursor="pointer"
                  src={
                    process.env.PUBLIC_URL + "/images/calculator/percent.png"
                  }
                  w={["calc(80% / 4)", null, null, null, "calc(90% / 4)"]}
                  onClick={() => setExpression(expression + "%")}
                />
                <Image
                  cursor="pointer"
                  src={process.env.PUBLIC_URL + "/images/calculator/submit.png"}
                  w={["calc(80% / 2)", "calc(90% / 2)"]}
                  h="100%"
                  onClick={submitExpression}
                />
              </HStack>
            </VStack>
          </Box>
        </Flex>
      </Collapse>
    </Box>
  );
};

export default Calculator;
